import React from "react";
import { AppBar, Stack, Toolbar } from "@mui/material";
import Logo from "../logo";
import AccountPopover from "./AccountPopover";
import UserRoleChip from "./UserRoleChip";

const Header = () => {
  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: "#FFFFFF",
        maxHeight: 70,
        px: { xs: 0, md: 3 },
        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
        borderRadius: 0,
      }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        <Logo />
        <Stack direction="row" alignItems="center" spacing={1}>
          <UserRoleChip />
          <AccountPopover />
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
